import React, { lazy, Suspense } from 'react';
import { Platform } from 'react-native';

const Web = lazy(() => import('./MoreVert.web'));
const Native = lazy(() => import('./MoreVert.native'));

export default function (props) {
  const Component = Platform.OS === 'web' ? Web : Native;
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
}
